<template>
  <tab-list
      v-model="currentTab"
      :tabs-enum="tabs"
      :title="title"
      fixed-tabs
      :default-tab="defaultTab"
      @change="changeTab">
    <template v-slot:tabItem="{ current }">
      <general-error v-if="!!generalError" />
      <user-request-list :status="current" />
    </template>
  </tab-list>
</template>

<script>
  import UserRequestList from './UserRequestList.vue'
  import TabList from '@/components/reused/ui/TabList.vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import { REQUEST_STATUS_ENUM } from '@/constants/enums'
  import { REQUEST_STATUSES } from '@/constants/business'

  export default {
    components: {
      TabList,
      UserRequestList,
      GeneralError
    },
    props: {
      tab: {
        type: String
      }
    },
    data () {
      return {
        tabs: REQUEST_STATUS_ENUM,
        currentTab: this.tab || REQUEST_STATUSES.INPROCESS,
        defaultTab: REQUEST_STATUSES.INPROCESS
      }
    },
    computed: {
      title () {
        return this.$t('Список запросов на регистрацию УП')
      }
    },
    methods: {
      changeTab: function (tabValue) {
        this.replaceCurrentRoute(this.getRoute(tabValue))
      },
      getRoute: function (tabValue) {
        return `${this.urlRootPath}/userRegistrationRequests/${tabValue}`
      }
    }
  }
</script>
